import React from 'react'
import { NavLink } from 'react-router-dom'

export interface SidebarMenuItem {
  key: string
  title: string
  to: string
  icon: React.ReactNode
  subKey?: string
  notInclude?: string[]
}

export const isMenuItemActive = (
  currentPath: string,
  to: string,
  key: string,
  subKey?: string,
  notInclude?: string[]
) => {
  let isActive = false
  if (
    currentPath.includes(to) ||
    currentPath.includes(key) ||
    (subKey && currentPath.includes(subKey))
  ) {
    if (
      notInclude &&
      notInclude.length > 0 &&
      notInclude.findIndex((item) => currentPath.includes(item)) !== -1
    ) {
      isActive = false
    } else {
      isActive = true
    }
  }
  return isActive
}

export const convertToMenuItems = (
  items: SidebarMenuItem[],
  getRecentsMenuItem: () => any,
  getDemoLeaguesMenuItem: () => any,
  getOrganizationsMenuItem?: () => any,
  getTeamsMenuItem?: () => any
) => {
  return items
    .map((item) => {
      if (item.key === 'recents') {
        return getRecentsMenuItem()
      }
      if (item.key === 'demo-leagues') {
        return getDemoLeaguesMenuItem()
      }
      if (item.key === 'organizations' && getOrganizationsMenuItem) {
        return getOrganizationsMenuItem()
      }
      if (item.key === 'teams' && getTeamsMenuItem) {
        return getTeamsMenuItem()
      }
      return {
        key: item.key,
        icon: item.icon,
        label: <NavLink to={item.to}>{item.title}</NavLink>,
      }
    })
    .filter(Boolean)
}
